
// import React, { useEffect } from 'react';

import logo from '../assets/Logos/Brewing-solutions-3.png';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <Navbar expand="lg" className="bg-body-tertiary header-section">
        <Container className='justify-content-between'>
            <Navbar.Brand href="/"><img src={logo} alt='logo' width="125" height="auto"/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
            <Nav>
            <NavLink  className="nav-link" to="/">
                 {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house-door-fill" viewBox="0 0 16 16">
                    <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
                    </svg>  */}
                    Home</NavLink> 
                    <NavLink  className="nav-link" to="/about-pints">About</NavLink>    
                    <NavLink  className="nav-link" to="/pints-products">Products</NavLink> 
               <NavLink  className="nav-link" to="/Pints-clients">Clients</NavLink> 
               <NavLink  className="nav-link contact--button" to="/contact-pints">Get Quotes</NavLink> 
                {/* <Nav.Link href='mailto:pouringpints@gmail.com'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                    </svg> pouringpints@gmail.com</Nav.Link>

                    <Nav.Link href="tel:+919901855334">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-phone-fill" viewBox="0 0 16 16">
                    <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/>
                    </svg> +91 9901855334
                </Nav.Link> */}
            </Nav>
            </Navbar.Collapse>
        </Container>
   </Navbar>
      

  );
}

export default Header;